// src/api/orders.js
import http from './http';

export async function ensureCsrf() {
  const { data } = await http.get('/api/auth/csrf');
  return data;
}

export async function createOrder(items, buyer = {}, extras = {}) {
  const { data } = await http.post('/api/orders', {
    buyer,
    items,
    ...extras,
  });
  return data;
}

export async function initTbankPayment(orderId, { force = false } = {}) {
  const { data } = await http.post(
    `/api/payments/tbank/init/${orderId}`,
    force ? { force: '1' } : {},
    force ? { params: { force: 1 } } : undefined
  );
  return data;
}
